import { z } from 'zod';
import { PartnerBillingType, PartnerInvoiceStatus } from '../../enums/Partner';
import { BaseSchema } from '../BaseSchema';
import { IuguFieldsSchema } from '../IuguFields';
import { PartnerSchema } from './Partner';
export var PartnerInvoiceSchema = BaseSchema.extend({
    partner: z.union([z.string(), PartnerSchema]),
    referralMonth: z.union([z.string().transform(function (v) { return new Date(Date.parse(v)); }), z.date()]),
    dueDate: z.union([z.string().transform(function (v) { return new Date(Date.parse(v)); }), z.date()]),
    paidAt: z.union([z.string().transform(function (v) { return new Date(Date.parse(v)); }), z.date()]).optional(),
    iuguFields: IuguFieldsSchema,
    status: z.nativeEnum(PartnerInvoiceStatus),
    workspacesCount: z.number(),
    amount: z.number(),
    billingType: z.nativeEnum(PartnerBillingType)
});
